import { useRequiredContext } from "@redotech/react-util/context";
import PackageCheckIcon from "@redotech/redo-icons/package-check.svg";
import PackageCheckFilledIcon from "@redotech/redo-icons/package-check_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { OrderManagementSuiteStatusesContext } from "../../../../redo-suite/order-management-cloud";

export const PickSessionsItem = memo(function PickSessionsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { wmsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const hasPermissionToViewItem = useHasPermission(
    OrderManagementPermissions.MANAGE_PICK_SESSIONS,
  );

  if (!wmsEnabled || !hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.pickSessionTableHref }}
      FilledIcon={PackageCheckFilledIcon}
      friendlyName="Pick sessions"
      id="pick-sessions"
      UnfilledIcon={PackageCheckIcon}
    />
  );
});
